<!-- conferenceDetails -->
<template>
  <div class="expertDetail">
    <div class="title_box">
      <h4>共识撰写详情</h4>
      <el-button
        size="small"
        type="info"
        @click="backProject"
      >返回</el-button>
    </div>
    <el-card>
      <div class="introduce">
        <div class="discribtion">
          <h5>{{ExpertDetail.name}}</h5>
          <p class="phons">
            执笔人：<span>{{Penmanship}}</span>
          </p>
          <p class="phons">
            版本号：
            <span v-if="ExpertDetail.version">{{ExpertDetail.version}}</span>
            <span v-else>暂无数据</span>
          </p>
        </div> 
      </div>
    </el-card>
    <div class="b_box">
      <div class="l_box">
        <ul class="l_sbox">
          <li>
            <div class="l_sbox-box">
              <h5 class="l_sbox-h5">参会专家</h5>
              <div class="l_sbox-div">
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="expert_id_str"
                  placement="top"
                >
                  <span class="expert-hide">{{expert_id_str}}</span>
                </el-tooltip>
              </div>
            </div>
            <div class="l_sbox-box">
              <h5 class="l_sbox-h5">共识投稿</h5>
              <div
                class="l_sbox-div"
                v-if="ExpertDetail.draft_name==''"
              >暂无稿件</div>
              <div
                v-else
                class="l_sbox-div"
                @click="ConsensusClick(ExpertDetail.draft)"
              >{{ExpertDetail.draft_name}}</div>
            </div>

            <div class="l_sbox-box">
              <h5 class="l_sbox-h5">参考文献</h5>
              <div
                class="l_sbox-div"
                v-if="ExpertDetail.reference_name=='' "
              >暂无稿件</div>
              <div
                v-else
                class="l_sbox-div"
                @click="LiteratureClick(ExpertDetail.reference)"
              >{{ExpertDetail.reference_name}}</div>
            </div>
          </li>
        </ul>
      </div>
      <div class="r_box">
        <h4>备注</h4>
        <span
          v-if="ExpertDetail.remarks=='' "
          class="kong"
        >暂无数据</span>
        <el-tooltip
          class="item"
          effect="dark"
          :content="ExpertDetail.remarks"
          placement="top"
        >
          <p class="hide">{{ExpertDetail.remarks}}</p>
        </el-tooltip>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "expertDetail",
  data () {
    return {
      ExpertDetail: {},
      expert_id_str: '',
      Penmanship: '',
    };
  },
  created () {
    this.getExpertDetail(this.$route.query.id);
  },
  methods: {
    async getExpertDetail (id) {
      const { data: data } = await this.$http.post("gs/info", {
        id
      });
      this.ExpertDetail = data.data;
      this.expert_id_str = data.data.expert_id_str.map(item => item.name).join('，')
      this.Penmanship = data.data.writer.map(item => item).join('，')
    },
    //共识url
    ConsensusClick (url) {
      this.$confirm('您是否下载', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        window.open(url);
      }).catch(() => { })
    },
    //文献url 
    LiteratureClick (url) {
      this.$confirm('您是否下载', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        window.open(url);
      }).catch(() => { })
    },
    //返回
    backProject () {
      this.$router.back();
    },
  },
}
</script>

<style lang='less' scoped>
.expertDetail {
  width: 100%;
  height: 100%;
  // overflow-y: auto;

  .title_box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #e8e8e8;
    padding-bottom: 16px;
    margin-bottom: 23px;
    h4 {
      font-size: 28px;
      color: #212529;
    }
  }
  .kong {
    display: flex;
    margin-top: 10px;
  }

  .el-card {
    margin-top: 20px;
    .introduce {
      width: 100%;
      display: flex;
      .header {
        width: 111px;
        height: 111px;
        border-radius: 50%;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
        }
        /deep/.el-image {
          width: 100%;
          height: 100%;
        }
      }
      .names {
        color: #9a9b9d;
        font-size: 16px;
        text-align: center;
        margin-top: 10px;
      }
    }
    .line {
      height: 173px;
      background: #e4e4e4;
      width: 1px;
      margin-left: 26px;
    }
    .discribtion {
      flex: 1;
      margin-left: 21px;
      h5 {
        font-size: 16px;
        color: #212529;
      }
      .hospital {
        margin-right: 26px;
        color: #9a9b9d;
        font-size: 12px;
        margin-top: 8px;
        // span {
        //   margin-right: 26px;
        //   color: #9a9b9d;
        //   font-size: 12px;
        // }
      }
      .text {
        margin-top: 20px;
        color: #212529;
        font-size: 13px;
        line-height: 24px;
        height: 48px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
      }
      .phons {
        margin-top: 37px;
        margin-bottom: 15px;
        color: #212529;
        font-size: 13px;
      }
    }
  }
  .b_box {
    // flex: 1;
    width: 100%;
    // height: 510px;
    margin-top: 20px;
    display: flex;
    .l_box {
      flex: 1;
      height: 100%;
      background: #fff;
      border: 1px solid #f0f0f0;
      display: flex;
      justify-content: space-between;
      padding: 32px;
      .l_sbox {
        width: 100%;
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        li {
          border: 1px solid #f0f0f0;
          border-radius: 8px;
          padding: 25px;
          .l_sbox-box {
            .l_sbox-h5 {
              font-size: 16px;
              color: #212529 !important;
              padding-bottom: 25px;
            }
            .l_sbox-div {
              font-size: 13px;
              color: #212529;
              padding-bottom: 73px;
              cursor: pointer;
            }
            &:nth-child(4) {
              .l_sbox-div {
                padding-bottom: 0px;
              }
            }
          }

          h4 {
            color: #212529;
            font-size: 16px;
          }
          p {
            font-size: 13px;
            color: #212529;
            margin-top: 10px;
            line-height: 24px;
            overflow: hidden; //超出隐藏
            text-overflow: ellipsis; //超出文本设置为...
            display: -webkit-box; //将div1转换为盒子模型
            -webkit-line-clamp: 2; //设置div1的文本为2行
            -webkit-box-orient: vertical; //从顶部向底部垂直布置子元素
          }
        }
      }
      .r_sbox {
        box-sizing: border-box;
        height: 100%;
        flex: 1;
        border: 1px solid #f0f0f0;
        margin-left: 27px;
        padding: 25px;
        h5 {
          font-size: 16px;
          color: #212529;
          margin-bottom: 30px;
        }
        p {
          font-size: 13px;
          color: #212529;
          cursor: pointer;
          transition: all 0.5s;
          margin-bottom: 46px;
          overflow: hidden; //超出隐藏
          text-overflow: ellipsis; //超出文本设置为...
          display: -webkit-box; //将div1转换为盒子模型
          -webkit-line-clamp: 2; //设置div1的文本为2行
          -webkit-box-orient: vertical; //从顶部向底部垂直布置子元素
          &:hover {
            color: #6167aa;
            font-weight: bold;
          }
        }
      }
    }
    .r_box {
      flex: 1;
      border: 1px solid #f0f0f0;
      border-radius: 8px;
      background: #fff;
      margin-left: 20px;
      padding: 25px 28px;
      h4 {
        color: #212529;
        font-size: 16px;
      }
      p {
        font-size: 13px;
        color: #212529;
        margin-top: 10px;
        line-height: 24px;
      }
    }
  }

  .hide {
    overflow: hidden; //超出隐藏
    text-overflow: ellipsis; //超出文本设置为...
    display: -webkit-box; //将div1转换为盒子模型
    -webkit-line-clamp: 19; //设置div1的文本为2行
    -webkit-box-orient: vertical; //从顶部向底部垂直布置子元素
    cursor: pointer;
  }

  .expert-hide {
    overflow: hidden; //超出隐藏
    text-overflow: ellipsis; //超出文本设置为...
    display: -webkit-box; //将div1转换为盒子模型
    -webkit-line-clamp: 2; //设置div1的文本为2行
    -webkit-box-orient: vertical; //从顶部向底部垂直布置子元素
    cursor: pointer;
  }
}
</style> 